function loaderConfig($httpProvider) {
    $httpProvider.interceptors.push(['$rootScope', '$q', function($rootScope, $q) {
        $rootScope.counter = 0;
        return {
            request: function(config) {
                ++$rootScope.counter;
                return config;
            },
            response: function(response) {
                --$rootScope.counter;
                return response;
            },
            requestError: function(rejection) {
                --$rootScope.counter;
                return $q.reject(rejection);
            },
            responseError: function(rejection) {
                --$rootScope.counter;
                return $q.reject(rejection);
            }
        };
    }]);
}

export default loaderConfig;



// WEBPACK FOOTER //
// ./src/app/app.loader.js